module.exports = __webpack_public_path__ + "static/bar_chart_2-187e17e6131fa584cab49a6423d6d89b.png";